import { selectFactory } from '../../helpers';

import * as Constants from '../constants';

import { collectValueFields, selectFields, selectFromCollect } from './helpers';

export const selectPages = selectFields(Constants.FIELDS.PAGES);

export const selectPage = selectFactory({ selector: selectPages });

export const selectPagesField = selectFactory({ selector: selectPages });

export const selectPagesDisabled = collectValueFields({
  field: Constants.PAGES_VALUE_FIELDS.DISABLED,
  selector: selectPages,
});

export const selectPageDisabled = selectFromCollect({ selector: selectPagesDisabled });

export const selectPagesErrors = collectValueFields({
  field: Constants.PAGES_VALUE_FIELDS.ERROR,
  selector: selectPages,
});

export const selectPageError = selectFromCollect({ selector: selectPagesErrors });

export const selectPagesLoadings = collectValueFields({
  field: Constants.PAGES_VALUE_FIELDS.LOADING,
  selector: selectPages,
});

export const selectPageLoading = selectFromCollect({ selector: selectPagesLoadings });

export const selectPagesPatching = collectValueFields({
  field: Constants.PAGES_VALUE_FIELDS.PATCHING,
  selector: selectPages,
});

export const selectPagePatching = selectFromCollect({ selector: selectPagesPatching });

export const selectPagesWarnings = collectValueFields({
  field: Constants.PAGES_VALUE_FIELDS.WARNING,
  selector: selectPages,
});

export const selectPageWarning = selectFromCollect({ selector: selectPagesWarnings });
